// components/GoogleMapsProvider.tsx
import React, { createContext, useState, useEffect, ReactNode } from 'react';
import { loadGoogleMaps, AUTH_ERROR_EVENT } from '../../services/googleMapsLoader';

interface GoogleMapsContextType {
    isLoaded: boolean;
    loadError: Error | null;
}

export const GoogleMapsContext = createContext<GoogleMapsContextType>({
    isLoaded: false,
    loadError: null,
});

interface GoogleMapsProviderProps {
    children: ReactNode;
}

export const GoogleMapsProvider: React.FC<GoogleMapsProviderProps> = ({ children }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [loadError, setLoadError] = useState<Error | null>(null);

    useEffect(() => {
        const handleAuthError = () => {
            setLoadError(new Error("Google Maps authentication failed. Please check your API key and enabled APIs."));
        };

        document.addEventListener(AUTH_ERROR_EVENT, handleAuthError);

        loadGoogleMaps()
            .then(() => {
                setIsLoaded(true);
            })
            .catch((error) => {
                setLoadError(error);
            });
        
        return () => {
            document.removeEventListener(AUTH_ERROR_EVENT, handleAuthError);
        };
    }, []);

    return (
        <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
            {children}
        </GoogleMapsContext.Provider>
    );
};